import { combineReducers } from 'redux';
import data from './data.reducer';

const medprocureReducers = combineReducers({
    data,
});

export default medprocureReducers;


// WEBPACK FOOTER //
// src/store/reducers/medprocure/index.js